import Page from "../../layout/Page";
import PageHeader from "../../layout/PageHeader";
import PageContent from "../../layout/PageContent";
import {useParams} from "react-router-dom";
import {ParamBrandHouse} from "../../Parameters";
import {ParcelsList} from "../shop/parcels/ParcelsList";
import {ParcelCreateDialog} from "../shop/parcels/ParcelCreateDialog";
import {useBrandConsumersPageShopsQuery} from "../../Queries";
import {useMemo, useState} from "react";
import Button from "@mui/material/Button";

export const BrandParcelsPage = () => {
   const {brandHouseId} = useParams<ParamBrandHouse>();
   const [createOpen, setCreateOpen] = useState(false);

   const {data: shopsData} = useBrandConsumersPageShopsQuery({
      variables: {brandHouseId: brandHouseId!},
      skip: !brandHouseId
   });

   const shopNames = useMemo(() => {
      const map: Record<string, string> = {};
      for (const shop of shopsData?.ShopMany || []) {
         map[shop._id] = shop.name || 'Unknown';
      }
      return map;
   }, [shopsData]);

   return <Page>
      <PageHeader title={"Parcels"}>
         <Button variant={"contained"} onClick={() => setCreateOpen(true)}>Create parcel</Button>
      </PageHeader>
      <PageContent>
         <ParcelsList brandHouseId={brandHouseId!} shopNames={shopNames}/>
         <ParcelCreateDialog
            open={createOpen}
            onClose={() => setCreateOpen(false)}
            onCreated={() => setCreateOpen(false)}
            brandHouseId={brandHouseId!}
         />
      </PageContent>
   </Page>
}
